import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import OverwatchPage from './pages/OverwatchPage';
import DashboardPage from './pages/DashboardPage';
import FieldsPage from './pages/FieldsPage';
import EquipmentPage from './pages/EquipmentPage';
import CrewPage from './pages/CrewPage';
import OperationsPage from './pages/OperationsPage';
import OperationDetailPage from './pages/OperationDetailPage';
import MaintenancePage from './pages/MaintenancePage';
import PayrollPage from './pages/PayrollPage';
import ExpensesPage from './pages/ExpensesPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ReportsPage from './pages/ReportsPage';
import WeatherPage from './pages/WeatherPage';
import LogisticsPage from './pages/LogisticsPage';
import ProfilePage from './pages/ProfilePage';
import OwnerDashboard from './pages/OwnerDashboard';
import './App.css';

// Geerts Farms owner email
const GEERTS_OWNER = 'Bcgeerts@execulink.com';

// Complete IQ Core Team — full owner access
const COMPLETE_IQ_TEAM = [
  'iod-master@islandoverheaddoors.com',
  'rmiskulin@gmail.com',
  'threewayindustries@gmail.com',
];

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" />;
  return children;
}

function RoleHomePage() {
  const { user } = useAuth();
  const email = user?.email?.toLowerCase();
  // Ian Geerts and admin team go to owner dashboard
  if (email === GEERTS_OWNER.toLowerCase() || COMPLETE_IQ_TEAM.map(e => e.toLowerCase()).includes(email)) return <Navigate to="/owner" />;
  const role = user?.role;
  if (role === 'operator') return <Navigate to="/dashboard" />;
  if (role === 'mechanic') return <Navigate to="/maintenance" />;
  if (role === 'camp_manager') return <Navigate to="/crew" />;
  if (role === 'logistics') return <Navigate to="/logistics" />;
  return <Navigate to="/dashboard" />;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<RoleHomePage />} />
        <Route path="overwatch" element={<OverwatchPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="owner" element={<OwnerDashboard />} />
        <Route path="fields" element={<FieldsPage />} />
        <Route path="equipment" element={<EquipmentPage />} />
        <Route path="crew" element={<CrewPage />} />
        <Route path="operations" element={<OperationsPage />} />
        <Route path="operations/:operationId" element={<OperationDetailPage />} />
        <Route path="maintenance" element={<MaintenancePage />} />
        <Route path="payroll" element={<PayrollPage />} />
        <Route path="expenses" element={<ExpensesPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="weather" element={<WeatherPage />} />
        <Route path="logistics" element={<LogisticsPage />} />
        <Route path="profile" element={<ProfilePage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
